import { IonImg } from '@ionic/react';
import { useIntl } from 'react-intl';

import { StageEnum } from '@typing/Generated';
import { imageUrl } from '@utils/imageUtils';

type Props = {
  className?: string;
  stage: StageEnum;
};

const StageImage = ({ className, stage }: Props) => {
  const intl = useIntl();
  return (
    <IonImg
      alt={intl.formatMessage({ id: `accessibility.altTags.stages.${stage}` })}
      className={className ? className : ''}
      src={imageUrl(stage)}
    />
  );
};

export default StageImage;
